import { gql, useQuery } from "@apollo/client";

const GET_WORK_ORDER_FOR_EMAILS = gql`
  query getWorkOrderForEmails($id: ID!) {
    getOwnOemTicketById(id: $id) {
      _id
      title
      facility {
        _id
      }
    }
  }
`;

export interface WorkOrderForEmails {
  _id: string;
  title: string;
  facility?: { _id: string } | null;
}

interface UseGetWorkOrderForEmailsResult {
  workOrder: WorkOrderForEmails | null;
  loading: boolean;
}

/**
 * Slim query for the Emails tab. WorkOrderPanel only consumes _id, title and the
 * facility id (drives the Company Contacts tab in the compose drawer).
 */
export const useGetWorkOrderForEmails = (
  id: string | undefined,
): UseGetWorkOrderForEmailsResult => {
  const { data, loading } = useQuery<{
    getOwnOemTicketById: WorkOrderForEmails | null;
  }>(GET_WORK_ORDER_FOR_EMAILS, {
    variables: { id },
    skip: !id,
  });

  return {
    workOrder: data?.getOwnOemTicketById ?? null,
    loading,
  };
};
